import { ReactNode } from "react";

type PageHeaderProps = {
    title: string;
    actions?: ReactNode;
};

/** Every screen renders its title through this so they share one heading token. */
export const PageHeader = ({ title, actions }: PageHeaderProps) => (
    <div className="flex align-items-center justify-content-between gap-3 mb-3">
        <h1 className="page-title m-0">{title}</h1>
        {actions && <div className="flex align-items-center gap-2">{actions}</div>}
    </div>
);
